﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("quickTags", {
            bindings: {
                tags: "=",
                values: "@"
            },
            templateUrl: ['version', function (version) {
                return `/js/components/quickTags/quickTags.html?v=${version}`
            }],
            controller: QuickTagsController,
            controllerAs: "vm"
        });

    QuickTagsController.$inject = ["$scope", "$rootScope", "$element"];

    function QuickTagsController($scope, $rootScope, $element) {
        var vm = this;

        vm.$onInit = onInit;

        vm.tagValues;

        vm.addTag = addTag;
        vm.hasTag = hasTag;

        function onInit() {
            if (!vm.values) vm.values = "documents,expenses,photos";

            vm.tagValues = vm.values.split(/,/gi);
        }

        function addTag(tag) {
            vm.tags.push({ 'text': tag });
        }

        function hasTag(tag) {
            if (!tag || !vm.tags) return false;
            tag = tag.toLowerCase();

            return vm.tags.some(function (t) {
                if (t.text) return t.text.toLowerCase() === tag;
                return t.toLowerCase() === tag;
            });
        }
    }
})();